export function validateLocalStoragePerPage(localStorageKey: string) {
  if (
    !localStorage.getItem(localStorageKey) ||
    Number(localStorage.getItem(localStorageKey)) <= 0 ||
    Number(localStorage.getItem(localStorageKey)) > 50 ||
    !Number.isInteger(Number(localStorage.getItem(localStorageKey)))
  ) {
    return 5;
  } else {
    return Number(localStorage.getItem(localStorageKey));
  }
}
